import { arrayOf, bool, func, object, oneOfType, shape, string } from 'prop-types'
import { useEffect, useRef } from 'react'

export default function Header({ items, showTooltip, rowFormat, dataKeys, selectableRow, allSelected, onToggleAll }) {
  const refs = useRef({})

  useEffect(() => {
    const checkEllipsisText = () => {
      if (showTooltip) {
        Object.keys(refs.current).forEach(key => {
          const element = refs.current[key]
          if (element) {
            const isEllipsisActive = el => el.scrollWidth > el.clientWidth
            if (isEllipsisActive(element)) {
              element.setAttribute('title', element.textContent)
            } else {
              element.removeAttribute('title')
            }
          }
        })
      }
    }
    checkEllipsisText()
    window.addEventListener('resize', checkEllipsisText)
    return () => {
      window.removeEventListener('resize', checkEllipsisText)
    }
  }, [showTooltip, items])

  const rendered = () => {
    if (typeof items[0]?.format === 'function') {
      return items.map(item => item.format())
    }
    return items.map((item, index) => {
      let classes = 'cell '
      if (typeof items[index] === 'function') {
        return <div key={items[index]}>{item()}</div>
      }
      if (
        rowFormat &&
        rowFormat[dataKeys[index]] &&
        rowFormat[dataKeys[index]].customStyle
      ) {
        if (
          rowFormat[dataKeys[index]]
            .overwriteStyles
        ) {
          classes =
            rowFormat[dataKeys[index]]
              .customStyle
        } else {
          classes =
            classes +
            rowFormat[dataKeys[index]]
              .customStyle
        }
      }
      return (
        <div key={item} className={classes} ref={el => refs.current[item] = el}>
          {item}
        </div>
      )
    })
  }
  const cells = rendered()
  if (selectableRow) {
    return [
      <div key='__checkbox_header' className='cell' style={{ flex: '0 0 32px' }}>
        <input
          type='checkbox'
          checked={allSelected}
          aria-label='Select all rows'
          onChange={onToggleAll}
        />
      </div>,
      ...cells
    ]
  }
  return cells
}

Header.propTypes = {
  items: arrayOf(
    oneOfType([
      string,
      func,
      shape({
        format: func
      })
    ])
  ).isRequired,
  showTooltip: bool,
  rowFormat: object,
  dataKeys: arrayOf(string).isRequired,
  selectableRow: bool,
  allSelected: bool,
  onToggleAll: func
}